// AD-2722 (Maria, 17 October 2026): the hover pop-ups on the contacts section, also used in the Add new contact box.
// The orders are named as in the DfE guidance "Understanding and dealing with issues relating to parental
// responsibility"; the Parental Responsibility text is the definition on the Application Form templates.
const CONTACT_HELP = {
    // Maria, 18 October 2026: how to write a phone number, including one from abroad
    phone: 'Numbers and spaces only. For an international number, use 00 in place of +, for example 0033 6 12 34 56 78.',
    // Maria, 18 October 2026
    account: 'Has an Admicity account',
    editContact: 'Edit contact',
    editHomeAddress: 'Edit home address',
    homeAddress: 'Home address',
    // Maria, 17 October 2026
    viewHomeAddress: 'View home address',
    deleteContact: 'Delete contact',
    hidden: 'A contact can only view and edit their own contact information.',
    priority: 'Contacts with Parental Responsibility should be given Priority 1 or Priority 2. Any other contacts should be given priority 3 or 4.',
    legalOrder: studentName => `A Legal Order is a court order restricting a person's access to, contact with or information about ${studentName}, such as a prohibited steps order, a specific issue order or a child arrangements order that limits contact. It does not mean an order that gives a person Parental Responsibility, such as a special guardianship order, a care order or an adoption order. A contact with this box ticked is not eligible for an Admicity parent account.`,
    parentalResponsibility: 'Parental Responsibility is held by a birth or adoptive parent, or anyone granted that responsibility under a Care Order, Child Arrangements (residence) Order, or Special Guardianship Order.'
};

export default CONTACT_HELP;
